import { render, staticRenderFns } from "./SdsCard.vue?vue&type=template&id=4804c7a5&scoped=true"
import script from "./SdsCard.vue?vue&type=script&lang=js"
export * from "./SdsCard.vue?vue&type=script&lang=js"
import style0 from "./SdsCard.vue?vue&type=style&index=0&id=4804c7a5&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804c7a5",
  null
  
)

export default component.exports